import React from 'react'

import FinalizeForm from './finalize_form.jsx'

let FinalizeRouter = () => ( // this doesn't have any nested routes to worry about, so we punt
  <FinalizeForm />
)

export default FinalizeRouter
